import { useState, useCallback } from 'react';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface Toast {
  id: string;
  message: string;
  type: ToastType;
  duration?: number;
}

// Global toast state (simples, sem context)
let toastListeners: ((toast: Toast) => void)[] = [];
let toastId = 0;

export const showToast = (
  message: string,
  type: ToastType = 'info',
  duration = 3000
) => {
  const id = `toast-${++toastId}`;
  const toast: Toast = { id, message, type, duration };
  
  toastListeners.forEach(listener => listener(toast));
  
  if (duration > 0) {
    setTimeout(() => {
      removeToast(id);
    }, duration);
  }
  
  return id;
};

export const removeToast = (id: string) => {
  toastListeners.forEach(listener => listener({ id, message: '', type: 'info' }));
};

export const useToast = () => {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const subscribe = useCallback((listener: (toast: Toast) => void) => {
    toastListeners.push(listener);
    return () => {
      toastListeners = toastListeners.filter(l => l !== listener);
    };
  }, []);

  return {
    toasts,
    setToasts,
    subscribe,
  };
};
